import type { IOorkV1DiagnosticReportCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1DiagnosticReportCustomControlData';

export const initialAfwijkingen = {
    cataract_od: false,
    cataract_os: false,
    glaucoom_od: false,
    glaucoom_os: false,
    pseudofaak_od: false,
    pseudofaak_os: false,
    md_nat_od: false,
    md_nat_os: false,
    md_droog_od: false,
    md_droog_os: false,
    drp_od: false,
    drp_os: false,
    amblyopie_od: false,
    amblyopie_os: false,
    aangeboren_nystagmus: false,
    verworven_nystagmus: false,
    anders_text: null,
};
export function oorkV1DiagnosticReportInitializeCustomControlData(): IOorkV1DiagnosticReportCustomControlData {
    return {
        afwijkingen_gevonden: null,
        afwijkingen: { ...initialAfwijkingen },
        toelichting_verworven_nystagmus: null,
        relevante_comorbiditeit: null,
        toelichting_relevante_comorbiditeit: null,
        aanvullende_informatie: null,
    };
}
